import React from "react";
import ExlyImage from "repoV2/features/Common/modules/ExlyImage/ExlyImage";
import { classNames } from "repoV2/utils/common/render/classNames";
import { useAboutSectionContext } from "repoV2/pages/sale/contexts/AboutSectionContext";
import { useMainCtaButtonContext } from "repoV2/pages/sale/contexts/MainCtaButtonContext";
import { Button } from "repoV2/components/common/Button";
import { getUnitsToShow } from "repoV2/utils/common/time/countDownTimer";
import { useBannerSectionContext } from "repoV2/pages/sale/contexts/BannerSectionContext";
import EmbedNUrlVideoPlayer from "repoV2/pages/sale/components/EmbedNUrlVideoPlayer/EmbedNUrlVideoPlayer";
import { ADD_VIDEO_OPTIONS, MEDIA_TYPE } from "repoV2/pages/sale/constants";
import { checkIsStringEmpty } from "repoV2/utils/common/dataTypes/string";
import { addAlphaToHex } from "repoV2/utils/common/color";
import mediaStyles from "src/features/Common/Common.module.scss";
import { useCountdownTimerSection } from "../../../../utils/common/useCountdownTimerSection";
import { useTemplate3Context } from "../../Template3Context";
import styles from "./AboutSection.module.scss";
import commonStyles from "../../common.module.scss";
import { CountdownTimer } from "../CountdownTimerSection/CountdownTimer/CountdownTimer";

const AboutSection = () => {
    const { theme } = useTemplate3Context();
    const { headerText, title, description } = useAboutSectionContext();
    const {
        title: bannerTitle,
        imgSrc,
        mediaType,
        videoSrc,
        videoSrcType,
        disableAutoPlay,
        hideControls,
    } = useBannerSectionContext();
    const {
        units,
        hide: hideCountdownTimer,
        hurryText,
        timeIsRunningOutText,
    } = useCountdownTimerSection();

    const unitsToShow = getUnitsToShow({
        allUnits: units,
        timerEnded: hideCountdownTimer,
        noOfTimeUnitsToShow: 4,
    });
    const parentRef = React.useRef<any>(null);

    const {
        ctaText,
        strikedOffText,
        onMainCtaClick,
        hide: hideCtaButton,
    } = useMainCtaButtonContext();

    const isMediaEmpty =
        mediaType === MEDIA_TYPE.IMAGE
            ? checkIsStringEmpty(imgSrc)
            : checkIsStringEmpty(videoSrc);
    const ctaButton = !hideCtaButton ? (
        <Button
            className={classNames(styles.mainCtaButton, "bg-white")}
            onClick={onMainCtaClick}
            style={{
                color: theme.colors.color8,
            }}
        >
            {ctaText}
            {strikedOffText ? (
                <span className="small">
                    &nbsp;<del>{strikedOffText}</del>
                </span>
            ) : null}
        </Button>
    ) : null;

    return (
        <div
            style={{
                background: `linear-gradient(45deg, ${theme.colors.color1} 0%, ${theme.colors.color2} 100%)`,
            }}
            className={classNames(styles.section)}
        >
            <div
                className={classNames(styles.header, "w-100 h-100")}
                style={{
                    background: addAlphaToHex(theme.colors.color6, 0.3),
                    color: theme.colors.color3,
                }}
            >
                <div className={classNames(styles.headerText)}>
                    {headerText}
                </div>
            </div>
            <div
                className={classNames(
                    commonStyles.maxWidthContainer,
                    commonStyles.section,
                    styles.aboutSectionContainer
                )}
            >
                {title ? (
                    <div
                        className={classNames(
                            styles.title,
                            mediaStyles.hideOnDesktop,
                            "word-break"
                        )}
                        style={{ color: theme.colors.color7 }}
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: title,
                        }}
                    />
                ) : null}

                {description ? (
                    <div
                        className={classNames(
                            styles.description,
                            mediaStyles.hideOnDesktop,
                            "word-break"
                        )}
                        style={{ color: theme.colors.color10 }}
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: description,
                        }}
                    />
                ) : null}
                <div className={styles.container}>
                    {!isMediaEmpty ? (
                        <div
                            className={classNames(
                                styles.imageContainer,
                                "w-100"
                            )}
                        >
                            {imgSrc && mediaType === MEDIA_TYPE.IMAGE ? (
                                <div
                                    className={classNames(
                                        styles.imageBorder,
                                        "text-center"
                                    )}
                                    style={{
                                        borderColor: theme.colors.color3,
                                        backgroundColor: theme.colors.color3,
                                    }}
                                >
                                    <ExlyImage
                                        fetchWidth={900}
                                        alt={title}
                                        src={imgSrc}
                                        className={styles.image}
                                    />
                                    {bannerTitle ? (
                                        <div
                                            className={classNames(
                                                styles.bannerTitle,
                                                "word-break"
                                            )}
                                            style={{
                                                color: theme.colors.color1,
                                            }}
                                            // eslint-disable-next-line react/no-danger
                                            dangerouslySetInnerHTML={{
                                                __html: bannerTitle,
                                            }}
                                        />
                                    ) : null}
                                </div>
                            ) : (
                                <div
                                    className={styles.ParentWrapper}
                                    ref={parentRef}
                                    style={{
                                        borderColor: theme.colors.color3,
                                    }}
                                >
                                    <EmbedNUrlVideoPlayer
                                        url={videoSrc}
                                        videoSrcType={videoSrcType}
                                        parentRef={parentRef}
                                        autoPlay={!disableAutoPlay}
                                        controls={!hideControls}
                                        className={
                                            videoSrcType ===
                                            ADD_VIDEO_OPTIONS.ADD_EMBED_CODE
                                                .slug
                                                ? styles.embedVideoPlayer
                                                : ""
                                        }
                                        volume={0}
                                        isMuted
                                    />
                                </div>
                            )}
                        </div>
                    ) : null}
                    <div className={styles.textContent}>
                        <div className={mediaStyles.hideOnMobile}>
                            {title ? (
                                <div
                                    className={classNames(
                                        styles.title,

                                        "word-break"
                                    )}
                                    style={{ color: theme.colors.color7 }}
                                    // eslint-disable-next-line react/no-danger
                                    dangerouslySetInnerHTML={{
                                        __html: title,
                                    }}
                                />
                            ) : null}
                            {description ? (
                                <div
                                    className={classNames(
                                        styles.description,

                                        "word-break"
                                    )}
                                    style={{ color: theme.colors.color10 }}
                                    // eslint-disable-next-line react/no-danger
                                    dangerouslySetInnerHTML={{
                                        __html: description,
                                    }}
                                />
                            ) : null}
                            {ctaButton}
                        </div>
                    </div>
                </div>
                <div className={mediaStyles.hideOnDesktop}>{ctaButton}</div>
                <div className={styles.timerContainer}>
                    {!hideCountdownTimer && timeIsRunningOutText ? (
                        <div
                            className={classNames(
                                styles.timeIsRunningOutText,
                                "word-break text-center"
                            )}
                            style={{ color: theme.colors.color10 }}
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{
                                __html: timeIsRunningOutText,
                            }}
                        />
                    ) : null}
                    {hideCountdownTimer ? null : (
                        <div className={styles.timerDiv}>
                            <CountdownTimer units={unitsToShow} />
                        </div>
                    )}
                    {!hideCountdownTimer && hurryText ? (
                        <div
                            className={classNames(
                                styles.hurryText,
                                "word-break text-center"
                            )}
                            style={{
                                color: theme.colors.color10,
                            }}
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{
                                __html: hurryText,
                            }}
                        />
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default AboutSection;
